import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  TextField,
  IconButton,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { Close } from "@mui/icons-material";

interface UploadDocumentsModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  order: any;
  onDocumentsUploaded: (docs: any) => void;
}

const UploadDocumentsModal = ({ 
  open, 
  setOpen, 
  order, 
  onDocumentsUploaded 
}: UploadDocumentsModalProps) => {
  const [docs, setDocs] = useState({
    panDoc: null,
    cmlDoc: null,
    cancelledChequeDoc: null,
  });

  const handleDocChange = (e: any) => {
    const { name, files } = e.target;
    setDocs({ ...docs, [name]: files[0] });
  };

  const handleSubmit = () => {
    onDocumentsUploaded(docs);
    handleClose();
  };

  const shouldUpload = {
    panDoc: !order?.panDoc,
    cmlDoc: !order?.cmlDoc,
    cancelledChequeDoc: !order?.cancelledChequeDoc,
  };

  const handleClose = () => {
    setOpen(false);
    setDocs({ panDoc: null, cmlDoc: null, cancelledChequeDoc: null });
  };

  const allRequiredFilesUploaded = () => {
    if (shouldUpload.panDoc && !docs.panDoc) return false;
    if (shouldUpload.cmlDoc && !docs.cmlDoc) return false;
    if (shouldUpload.cancelledChequeDoc && !docs.cancelledChequeDoc)
      return false;
    return true;
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        className="bg-white p-6 rounded-xl shadow-lg"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="h6">Upload Documents</Typography>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>

        {/* Order Summary Table */}
        <Table size="small" className="mb-4">
          <TableBody>
            <TableRow>
              <TableCell>
                <strong>Stock</strong>
              </TableCell>
              <TableCell>{order?.stockName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>Investor</strong>
              </TableCell>
              <TableCell>{order?.investorName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>Type</strong>
              </TableCell>
              <TableCell>{order?.type}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>Qty</strong>
              </TableCell>
              <TableCell>{order?.quantity}</TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <div className="space-y-4">
          {shouldUpload.panDoc && (
            <TextField
              type="file"
              name="panDoc"
              onChange={handleDocChange}
              fullWidth
              helperText="Upload PAN Document"
              InputLabelProps={{ shrink: true }}
            />
          )}
          {shouldUpload.cmlDoc && (
            <TextField
              type="file"
              name="cmlDoc"
              onChange={handleDocChange}
              fullWidth
              helperText="Upload CML Document"
              InputLabelProps={{ shrink: true }}
            />
          )}
          {shouldUpload.cancelledChequeDoc && (
            <TextField
              type="file"
              name="cancelledChequeDoc"
              onChange={handleDocChange}
              fullWidth
              helperText="Upload Cancelled Cheque"
              InputLabelProps={{ shrink: true }}
            />
          )}
          {!Object.values(shouldUpload).includes(true) && (
            <Typography color="textSecondary">
              All required documents already uploaded.
            </Typography>
          )}
        </div>

        {/* Action Buttons */}
        <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            className="bg-blue-600 text-white"
            onClick={handleSubmit}
            disabled={!allRequiredFilesUploaded()}
          >
            Done
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UploadDocumentsModal; 